module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/jetSkiFeatured1.webp";